import React, { useEffect, useState } from 'react'; // [수정됨] useState, useEffect 유지
// CSS imports [제거 금지]
import 'styles/Font.css';

// Image imports [제거 금지]
import deleteIcon from "assets/images/icon/card-delete-icon.svg"

// Components imports [제거 금지]
import TopNavigator from "components/layout/TopNavigator/TopNavigator";
import ConfirmModal from "components/ui/Modals/ConfirmModal/ConfirmModal";
import { useToast } from "components/ui/Toast/ToastProvider";


function CardRegistration() {
    // useToast 훅 사용: showToastSuccess 함수를 가져옵니다.
    const { showToastSuccess } = useToast();

    // 카드 목록을 관리합니다. (isLoading 제거)
    const [cards, setCards] = useState([]);
    // 삭제 확인용 state 추가
    // null 이면 모달 닫힘, 카드 객체가 있으면 모달 열림
    const [cardToDelete, setCardToDelete] = useState(null);

    // 컴포넌트 마운트 시 카드 목록을 불러옵니다.
    useEffect(() => {
        // --- 여기부터 PG사 또는 백엔드 API 호출 로직 ---
        const fetchCardList = async () => {
            try {
                // 예: const response = await yourApi.get('/cards');
                // setCards(response.data);

                // --- 임시 테스트용 코드 (API 연동 시 아래 코드를 실제 API 호출로 대체) ---
                // [테스트 1] 카드가 1개 이상일 때
                const dummyData = [
                    { id: 1, company: '신한카드', logoUrl: 'assets/card/shinhan-logo.svg' },
                    { id: 2, company: '현대카드', logoUrl: 'assets/card/hyundai-logo.svg' },
                ];
                setCards(dummyData);

                // [테스트 2] 카드가 없을 때 (위 dummyData를 빈 배열 []로 바꾸세요)
                // setCards([]);
                // --- 임시 테스트 코드 끝 ---

            } catch (error) {
                console.error("카드 목록을 불러오는데 실패했습니다.", error);
            }
        };

        fetchCardList();
    }, []); // [] : 처음 한 번만 실행

    // 기존 삭제 로직 (이름 변경)
    // 이 함수는 모달에서 '확인'을 눌렀을 때만 실행됩니다.
    const executeDelete = (cardId) => {
        setCards(currentCards =>
            currentCards.filter(card => card.id !== cardId)
        );
        // + API 삭제 요청
    };

    // 삭제 버튼 클릭 시 (모달 열기)
    // 이제 삭제 아이콘은 이 함수를 호출합니다.
    const requestDelete = (card) => {
        setCardToDelete(card); // 삭제할 카드를 state에 저장 (모달 열림)
    };

    // 모달에서 '확인' 눌렀을 때
    const handleConfirmDelete = () => {
        if (cardToDelete) {
            executeDelete(cardToDelete.id); // 실제 삭제 실행
            setCardToDelete(null); // 모달 닫기

            // [수정됨] useToastSuccess 호출
            showToastSuccess('카드가 삭제 되었습니다');
        }
    };

    // 모달에서 '취소' 눌렀을 때
    const handleCancelDelete = () => {
        setCardToDelete(null); // 모달 닫기
    };


    // 로딩 및 카드 목록 상태에 따라 분기 처리하는 함수
    const renderCardList = () => {
        // 카드가 없을 때
        if (cards.length === 0) {
            return (
                <div style={staticStyles.emptyCardList}>
                    <p>등록된 카드가 없습니다</p>
                </div>
            );
        }

        // 카드가 있을 때
        // renderCardList의 onClick 수정
        return cards.map((card, index) => (
            <React.Fragment key={card.id}>
                {/* index 0 (첫번째 카드) 외에는 상단에 바 표시 */}
                {index > 0 && <div className="horizonBar" style={staticStyles.horizonBar} />}

                <div className="registrationCardInfo" style={staticStyles.registrationCardInfo}>
                    {/* 왼쪽: 로고 + 카드사 이름 */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', }}>
                        <img
                            className="cardLogoIcon"
                            src={card.logoUrl || "assets/images/default-card-logo.svg"} // 로고 없으면 기본 이미지
                            alt={`${card.company} 로고`}
                            style={staticStyles.cardLogoIcon} // 스타일 추가
                        />
                        <span style={{ color: '#FFFFFF', fontFamily: 'Pretendard', fontWeight: 500 }}>
                            {card.company}
                        </span>
                    </div>

                    {/* 오른쪽: 삭제 아이콘 */}
                    <img
                        className="deleteIcon"
                        src={deleteIcon}
                        alt="delete"
                        style={staticStyles.deleteIcon}
                        // onClick에 requestDelete(card) 연결
                        onClick={() => requestDelete(card)}
                    />
                </div>
            </React.Fragment>
        ));
    };


    return (
        <div className="backgroundWrapper" style={staticStyles.BackgroundWrapper}>
            <div style={staticStyles.fixedHeaderWrapper}>
                {/* 상단 상태바 */}
                <div className="statusBar" style={staticStyles.statusBar} />

                {/* 헤더 네비게이션 */}
                <TopNavigator title="카드 등록" />
            </div>

            <main style={staticStyles.mainContent}>
                {/* 카드 목록 */}
                <div className="cardListDiv" style={staticStyles.cardListDiv}>
                    <p className="cardListTitle" style={staticStyles.cardListTitle}>카드 목록</p>
                    <div className="cardListContent" style={staticStyles.cardContentBox}>

                        {renderCardList()}

                    </div>
                </div>

                {/* 카드 등록 버튼 */}
                <button className="cardRegisterButton" style={staticStyles.cardRegisterButton}>
                    등록하기
                </button>

                {/* 모달 컴포넌트 렌더링 */}
                <ConfirmModal
                    isOpen={!!cardToDelete} // state가 null이 아니면 true
                    onClose={handleCancelDelete}
                    onConfirm={handleConfirmDelete}
                    title="카드 삭제"
                    message={
                        // 템플릿 리터럴을 사용해 동적 메시지 생성
                        `'${cardToDelete?.company}' 카드를\n목록에서 삭제하시겠습니까?`
                    }
                />
            </main>
        </div>
    );
}

// [!!] staticStyles 객체 (최종본)
/** @type {React.CSSProperties} */
const staticStyles = {
    // --- 1. 전체 레이아웃 ---
    BackgroundWrapper: {
        background: '#0D042D',
        width: '100%',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        margin: '0 auto',
        boxSizing: 'border-box',
    },
    // 고정 헤더 컨테이너
    fixedHeaderWrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 100,
        backgroundColor: '#0D042D',
    },
    statusBar: {
        // height: 'env(safe-area-inset-top, 47px)',
        flexShrink: 0,
        backgroundColor: 'transparent',
    },
    mainContent: {
        flex: 1,
        padding: '134px 24px 24px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '19px',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    },
    horizonBar: {
        width: '100%',
        height: '1px',
        background: '#3A394A',
    },

    // --- 2. 카드 목록 (수정됨) ---
    cardListDiv: {
        width: '100%',
        color: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    cardListTitle: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        fontSize: '20px',
        color: '#FFFFFF',
        margin: 0,
    },
    cardContentBox: {
        width: '100%',
        background: '#1B1931',
        borderRadius: '10px',
        paddingLeft: '22px',
        paddingRight: '22px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
    },
    registrationCardInfo: {
        width: '100%',
        height: '57px',
        background: "transparent",
        border: 'none',
        display: 'flex',
        justifyContent: 'space-between', // 왼쪽(로고+이름)과 오른쪽(삭제)을 분리
        alignItems: 'center',
        padding: 0,
    },
    // 카드 로고 아이콘 스타일
    cardLogoIcon: {
        width: '32px',
        height: '32px',
        objectFit: 'contain', // 로고 비율 유지
        borderRadius: '4px', // (선택) 로고 모서리 살짝
        backgroundColor: 'transparent', // (선택) 로고 로딩 전 배경
    },
    deleteIcon: {
        width: '24px',
        height: '24px',
        cursor: 'pointer', // 클릭 가능 표시
    },
    // 카드가 없거나 로딩 중일 때 표시할 스타일
    emptyCardList: {
        width: '100%',
        height: '57px', // cardContentBox의 minHeight와 유사하게
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#888888', // 텍스트 색상
        fontFamily: 'Pretendard',
        fontSize: '16px',
    },

    // --- 3. 하단 버튼 ---
    cardRegisterButton: {
        border: 'none',
        background: 'linear-gradient(90deg, #8052FF 0%, #0231FB 100%)',
        height: '56px',
        borderRadius: '6px',
        position: 'fixed',
        left: '24px',
        right: '24px',
        bottom: 'calc(24px + env(safe-area-inset-bottom, 0px))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        color: 'white',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
}

export default CardRegistration;